<template>
  <div>
    <v-container>
      <h1>Project File Setup</h1>
      <!-- <v-card> -->
      <!-- <v-toolbar flat color="primary" dark>
          <v-toolbar-title>PM</v-toolbar-title>
      </v-toolbar>-->
      <v-tabs vertical>
        <v-tab class="text-none">Project List</v-tab>
        <v-tab class="text-none">Project Details</v-tab>

        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <!-- <router-view /> -->
              <project-list></project-list>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <!-- <router-view /> -->
              <project-details></project-details>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <!-- </v-card> -->
    </v-container>
  </div>
</template>
<script>
import ProjectList from "./project-list/Index";
import ProjectDetails from "./project-details/Index";
// import Approver from "./approver/Index";
export default {
  metaInfo: {
    title: "Project File",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`
  },
  data: () => ({
    tab: "1"
  }),
  components: {
    ProjectList,
    ProjectDetails
    // Approver
  }
};
</script>
